import { defineMessages } from 'react-intl';

export default defineMessages({
  learnHowLink: {
    id: 'frontbucket.pullRequestsList.learnHowLink',
    description: 'A link to more information about creating pull request.',
    defaultMessage: 'Learn how',
  },
  description: {
    id: 'frontbucket.pullRequestsList.emptyStateDescription',
    description: 'Descriptive text on pull requests list empty state screen',
    defaultMessage:
      'Get others to review and discuss your code in pull requests',
  },
  header: {
    id: 'frontbucket.pullRequestsList.overview.emptyStateHeader',
    description: 'Header of pull requests list empty state screen',
    defaultMessage: 'Collaborate and improve code quality',
  },
});
